import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';

import { ICalendarState, IEventMonth } from "@adage/ace-calendar";
import { IWACEvent, InputOption, ICalendarReduxState, transitionWidthPx } from "../classes";
import { connect } from "react-redux";

import Dropdown from '../components/dropdown';
import MonthDropdown from '../components/month-dropdown';
import AdaCheckbox from '../views/ada-checkbox';
import Exit from '../views/exit';
import CalendarMode from '../components/calendar-mode';
import DaysOfTheWeek from '../components/days-of-the-week';
import FiltersModal from '../containers/filters-modal';

import { MediaQueryProps } from 'react-responsive';
var MediaQuery: React.ComponentClass<MediaQueryProps> = require('react-responsive');


interface MobileFiltersExternalProps {
}

interface StateToProps {
    evts: Array<IEventMonth<IWACEvent>>;
    isGrid: boolean;
}

type MobileFiltersProps = MobileFiltersExternalProps & StateToProps;

interface MobileFiltersState {
    showModal: boolean;
}

class MobileFilters extends React.Component<MobileFiltersProps, MobileFiltersState> {
    constructor(props: MobileFiltersProps) {
        super(props);

        this.state = {
            showModal: false
        };
    }

    private boundOnOpenFiltersClick = this.onOpenFiltersClick.bind(this);

    private onOpenFiltersClick(evt: React.MouseEvent<HTMLButtonElement>) {
        evt.preventDefault();

        this.setState({
            showModal: true
        });
    }

    private boundOnCloseModal = this.onCloseModal.bind(this);

    private onCloseModal() {
        this.setState({
            showModal: false
        });
    }

    /**
     * Render
     */
    render() {
        return (
            <header className={`cal-header`}>
                <nav className="cal-nav cal-nav-mobile">
                    <div className="cal-nav-inner">
                        <button type="button" onClick={this.boundOnOpenFiltersClick} className="un-button cal-nav-mobile-trigger">Filters</button>
                        <MonthDropdown />
                        <Exit />
                    </div>
                </nav>
                <FiltersModal showModal={this.state.showModal} onHideModal={this.boundOnCloseModal} />
            </header>
        );
    }
}

function mapStateToProps(state: ICalendarReduxState, externalProps: MobileFiltersExternalProps) {
    return {
        evts: state.calendarModel.events,
        isGrid: state.calendarModeModel.isGrid
    }
}

export default connect<StateToProps>(mapStateToProps)(MobileFilters);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/containers/filters-mobile.tsx